import React, { useEffect, useState, useRef } from "react";
import "../../HomeWork/Pending/QuestionTypes/QuestionType.css";
import SucessfullySubmited from "../SucessfullySubmited";
import { useSelector } from "react-redux";
import moment from "moment";
import { iconData } from "../../../iconData";
import PdfViewer from "../../PdfViewer/PdfViewer";
import axios from "../../../axios";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { IP } from "../../../internalServer";
import { Player } from "video-react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ConfirmPopupActivity from "../ConfirmPopupActivity";
import { Award } from "lucide-react";

export default function ActivityPendingSubjDetail() {
  const navigate = useNavigate();
  const [homeMain, setHomeMain] = useState([]);
  const { state } = useLocation();
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [activitySubDetail, setActivitySubDetail] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [attachmentSize, setAttachmentSize] = useState([]);
  const [handleVideoClick, setHandleVideoClick] = useState(false);
  const [attachMent, setAttachment] = useState([]);
  const userId = useSelector((state) => state?.user?.currentUser?.id);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
    attachment: null,
  });
  const [activityResponse, setActivityResponse] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState();
  const [attachFile, setAttachFile] = useState([]);
  const [descriptive_answer, setDescriptive_answer] = useState("");
  const [isGettingData, setIsGettingData] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isConfirmPopup, setIsConfirmPopup] = useState(false);
  const [showDetails, setShowDetails] = useState(true);
  const [mideaviewer, setMideaviewer] = useState(false);

  // 🔥 Get entryType and gradeScale from homeMain
  const entryType = homeMain?.entryType || null;
  const gradeScale = homeMain?.gradeScaleId || null;
  const totalMarks = homeMain?.total_marks || 0;

  // Helper function to render grade/marks info in header
  const renderGradeOrMarksInfo = () => {
    // If entryType is "Grade" - show grade scale
    if (entryType === "Grade" && gradeScale) {
      return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Award size={16} style={{ color: "#6366f1" }} />
          <span
            style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}
          >
            Grade Scale:
          </span>
          <span
            style={{ fontSize: "0.9rem", fontWeight: 700, color: "#4338ca" }}
          >
            {gradeScale.name}
          </span>
          <span
            className="badge"
            style={{
              backgroundColor: "#6366f1",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            Grade
          </span>
        </div>
      );
    }

    // If entryType is "Marks" - show total marks
    if (entryType === "Marks") {
      return (
        <div className="d-flex align-items-center gap-2">
          <span
            style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}
          >
            Total Marks
          </span>
          <span
            style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}
          >
            {totalMarks || 0}
          </span>
          <span
            className="badge"
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            Marks
          </span>
        </div>
      );
    }

    // If no entryType or "None" - show total marks (fallback)
    return (
      <div className="d-flex align-items-center gap-2">
        <span style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}>
          Total Marks
        </span>
        <span style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}>
          {totalMarks || 0}
        </span>
      </div>
    );
  };

  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
      attachment: null,
    });
    setIsOpen(null);
  };

  useEffect(() => {
    const getResponse = async () => {
      try {
        let res = await axios.get(
          `/homework/activity/${state.activityId}/studentResponse/getByStudentAndActivityId/${userId}`,
        );
        let res1 = await axios.get(
          `/homework/activity/getById/${state.activityId}`,
        );
        res1 && setHomeMain(res1.data.data);
        res && setActivityResponse(res.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    getResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getActivityDetails = async () => {};
  console.log(homeMain);
  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const timeHelper2 = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();
    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleAttachment = async (files) => {
    let attachments = [];
    let attachmentSizes = [];
    let totalSize = attachedFiles.reduce(
      (accumulator, current) => accumulator + current.size,
      0,
    );
    if (files) {
      for (const file of files) {
        console.log(file);
        if (
          totalSize + file.size < 10 * 1024 * 1024 &&
          validateFileType(file)
        ) {
          try {
            let formData = new FormData();
            formData.append("name", file.name);
            formData.append("uploadResponseAttachment", file);
            let res = await axios.post(
              `/activity/studentResponse/uploadAttachment/studentId/${userId}`,
              formData,
            );
            res && setAttachmentSize((prev) => [...prev, file.size]);
            res && setAttachment((prev) => [...prev, file]);
            res && attachments.push(res.data.data);
            res &&
              setAttachedFiles((prev) => {
                attachmentSizes.push(...attachmentSize, file.size);
                return [...prev, file];
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          setIsValidFileType(false);
        }
      }
      if (attachments.length > 0) {
        setAttachFile((prev) => [...prev, ...attachments]);
      }
    }
  };

  const handleRemoveAttachment = async (attachment, index) => {
    try {
      let res = await axios.delete(`/file/delete`, {
        data: { file_path: attachment },
      });
      const newArrayLimit = [...attachedFiles];
      newArrayLimit.splice(index, 1);
      res && setAttachedFiles(newArrayLimit);
      const newAttSize = [...attachmentSize];
      newAttSize.splice(index, 1);
      const newAtt = [...attachMent];
      newAtt.splice(index, 1);
      setAttachment(newAtt);
      if (res) {
        setAttachmentSize(newAttSize);
        setAttachFile((prev) => prev.filter((i) => i !== attachment));
        setIsValidFileType(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickForVideo = (attachment) => {
    setResponseAttach(attachment);
    setHandleVideoClick(!handleVideoClick);
  };

  const handleSubmit = async () => {
    try {
      let res = await axios.post(
        `/homework/activity/${state.activityId}/studentResponse/create`,
        {
          student_id: userId,
          attachments: attachFile,
          attachments_sizeKb: attachmentSize,
          description: descriptive_answer,
          submitted_on: moment(Date(Date.now())).format(),
        },
      );
      res && setActivitySubDetail(true);
    } catch (error) {
      console.log(error);
    }
  };

  async function handleTakePhoto(dataUri) {
    let attachments = [];
    let attachmentSizes = [];
    const totalSize = attachedFiles.reduce(
      (accumulator, current) => accumulator + current.size,
      0,
    );
    const fileExtension = "jpg" || "jpeg" || "png";
    const filename = `${`capture`}.${fileExtension}`;
    const link = document.createElement("a");
    link.href = dataUri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (dataUri) {
      try {
        const capture = await fetch(dataUri).then((res) => res.blob());
        const fileWithProperExtension = new File([capture], filename, {
          type: capture.type || "image/jpeg",
        });
        if (
          totalSize + fileWithProperExtension.size < 10 * 1024 * 1024 &&
          validateFileType(fileWithProperExtension)
        ) {
          const formData = new FormData();
          formData.append("name", filename);
          formData.append("uploadResponseAttachment", fileWithProperExtension);

          let response = await axios.post(
            `/activity/studentResponse/uploadAttachment/studentId/${userId}`,
            formData,
          );
          if (response) {
            alert("Photo uploaded successfully!");
            setAttachmentSize((prev) => [
              ...prev,
              fileWithProperExtension.size,
            ]);
            setAttachment((prev) => [...prev, fileWithProperExtension.type]);
            attachments.push(response.data.data);
            setAttachedFiles((prev) => {
              setAttachedFiles([...prev, fileWithProperExtension]);
              attachmentSizes.push(
                ...attachmentSize,
                fileWithProperExtension.size,
              );
              return [...prev, fileWithProperExtension];
            });
          } else {
            console.error("Failed to upload photo:", response.statusText);
            alert("Failed to upload photo.");
          }
        } else {
          setIsValidFileType(false);
        }
      } catch (error) {
        console.error("Error uploading photo:", error);
        alert("An error occurred during the upload.");
      }
      if (attachments.length > 0) {
        setAttachFile((prev) => [...prev, ...attachments]);
      }
    }
  }

  useEffect(() => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.style.width = "400px";
      videoElement.style.height = "283px";
    }
  }, [activityResponse, isCameraOpen]);

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.pdf|\.ppt|\.pptx|\.jpg|\.jpeg|\.png|\.mp3|\.mp4)$/i;

    if (!allowedExtensions.exec(filePath.name) || attachedFiles.length >= 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };
  let From = localStorage.getItem("From");

  const handlePlayerError = (error) => {
    console.error("Error loading video:", error);
  };
  const attachformat = (para) => {
    const filePath = para;
    const fileName = filePath.split("/").pop();
    const fileNameWithoutId = fileName.split("_")[1];
    return fileNameWithoutId;
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };
  const handleCameraError = (error) => {
    console.error("Camera error:", error);
    alert("Unable to access the camera. Please check your device settings.");
  };

  !isValidFileType &&
    toast.error(`Exceeded Limit !!
      Max 5 attachments and total of 10 MB size is allowed.`);
  return (
    <>
      {homeMain ? (
        <div className="d-flex  gap-1">
          <div className="w-100">
            <div>
              {/* ── Header / Title Bar ── */}
              <div className="d-flex align-items-center gap-3 w-100 mb-4">
                {/* Back Button */}
                <div
                  onClick={() => {
                    From === "DCM"
                      ? navigate("/Calender")
                      : window.history.back();
                  }}
                  style={{
                    cursor: "pointer",
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    background: "#f1f5f9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    transition: "0.2s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#e2e8f0")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#f1f5f9")
                  }
                >
                  <img
                    src="/HwImg/backArrow.png"
                    alt="Back"
                    style={{ width: "18px" }}
                  />
                </div>
                {/* Title + Status — gap-2 */}
                <div
                  className="d-flex align-items-center justify-content-between gap-2 flex-wrap"
                  style={{ flex: 1 }}
                >
                  <div className="d-flex flex-row align-items-center gap-2">
                    <span
                      className="quesHeading"
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: 700,
                        color: "#1e293b",
                        lineHeight: 1.3,
                      }}
                    >
                      {homeMain?.name}
                    </span>

                    <span
                      style={{
                        background: "#fff7ed",
                        color: "#c2410c",
                        border: "1px solid #fed7aa",
                        padding: "4px 12px",
                        borderRadius: "999px",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Pending
                    </span>

                    {/* 🆕 Entry Type Badge */}
                    {entryType && entryType !== "None" && (
                      <span
                        style={{
                          background:
                            entryType === "Grade" ? "#6366f1" : "#28a745",
                          color: "#fff",
                          padding: "4px 12px",
                          borderRadius: "999px",
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {entryType}
                      </span>
                    )}
                  </div>
                </div>

                {/* 🆕 Grade/Marks Info Box */}
                <div
                  className="d-flex align-items-center gap-3"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    padding: "8px 16px",
                    borderRadius: "10px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {renderGradeOrMarksInfo()}
                </div>
              </div>

              <div className="PendingActivitySubContainer">
                {/* ═══════════════════════════════════════════════════
                  QUESTION / ACTIVITY SECTION
                  ═══════════════════════════════════════════════════ */}
                <div
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    borderRadius: "12px",
                    padding: "20px",
                    marginBottom: "24px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: 700,
                      color: "#6c757d",
                      textTransform: "uppercase",
                      letterSpacing: "0.6px",
                      marginBottom: "14px",
                      borderBottom: "1px solid #dee2e6",
                      paddingBottom: "8px",
                    }}
                  >
                    📋 Activity Details
                  </div>
                  {/* Modern Activity Info + Description */}
                  <div
                    className="mt-3"
                    style={{
                      border: "1px solid #e2e8f0",
                      borderRadius: "18px",
                      overflow: "hidden",
                      background: "#ffffff",
                      boxShadow: "0 4px 14px rgba(0,0,0,0.04)",
                    }}
                  >
                    {/* Header */}
                    <div
                      onClick={() => setShowDetails(!showDetails)}
                      className="d-flex justify-content-between align-items-center px-3 py-3 flex-wrap gap-2"
                      style={{
                        cursor: "pointer",
                        background:
                          "linear-gradient(135deg, #fff7ed 0%, #fef3c7 100%)",
                      }}
                    >
                      {/* Left Content */}
                      <div className="d-flex flex-column gap-2">
                        {/* Subject + Deadline */}
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <span
                            style={{
                              background: "#fff",
                              padding: "6px 14px",
                              borderRadius: "999px",
                              fontSize: "13px",
                              fontWeight: 600,
                              color: "#92400e",
                              border: "1px solid #fde68a",
                            }}
                          >
                            📘 {homeMain?.subject_id?.name}
                          </span>

                          <span
                            style={{
                              background: "#fff",
                              padding: "6px 14px",
                              borderRadius: "999px",
                              fontSize: "13px",
                              fontWeight: 600,
                              color: "#7c2d12",
                              border: "1px solid #fed7aa",
                            }}
                          >
                            ⏰ Deadline: {timeHelper(homeMain?.deadline)}
                          </span>

                          {/* 🆕 Entry Type Badge in Description */}
                          {entryType && entryType !== "None" && (
                            <span
                              style={{
                                background:
                                  entryType === "Grade" ? "#6366f1" : "#28a745",
                                color: "#fff",
                                padding: "4px 12px",
                                borderRadius: "999px",
                                fontSize: "11px",
                                fontWeight: 600,
                              }}
                            >
                              {entryType}
                            </span>
                          )}
                        </div>

                        {/* Description label */}
                        <div>
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: 700,
                              color: "#92400e",
                            }}
                          >
                            📝 Activity Description
                          </span>

                          <div
                            style={{
                              fontSize: "12px",
                              color: "#78716c",
                              marginTop: "2px",
                            }}
                          >
                            Click to {showDetails ? "hide" : "view"} full
                            description
                          </div>
                        </div>
                      </div>

                      {/* Toggle Button */}
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "50%",
                          background: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "20px",
                          fontWeight: 700,
                          color: "#92400e",
                          flexShrink: 0,
                          transition: "0.3s",
                        }}
                      >
                        {showDetails ? "−" : "+"}
                      </div>
                    </div>

                    {/* Collapsible Body */}
                    <div
                      style={{
                        maxHeight: showDetails ? "220px" : "0px",
                        overflow: "hidden",
                        transition: "all 0.35s ease",
                      }}
                    >
                      <div
                        className="ActivityDtailText orange-scrollBar"
                        style={{
                          padding: "18px",
                          whiteSpace: "pre-wrap",
                          lineHeight: 1.7,
                          color: "#475569",
                          fontSize: "14px",
                          maxHeight: "180px",
                          overflowY: "auto",
                        }}
                      >
                        {homeMain?.description || "No description available"}
                      </div>
                    </div>
                  </div>
                  {/* ── Activity Lab Card (Student View) ── */}
                  {homeMain?.activity_type === "Lab" && homeMain?.lab_ref && (
                    <div className="mt-4 mb-2">
                      <div
                        className="p-3"
                        style={{
                          backgroundColor: "#fff7ed",
                          border: "2px solid #f97316",
                          borderRadius: "16px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-3 flex-wrap">
                          <img
                            src={homeMain.lab_ref.thumbnailUrl}
                            alt={homeMain.lab_ref.title}
                            style={{
                              width: "130px",
                              height: "85px",
                              objectFit: "cover",
                              borderRadius: "10px",
                              border: "1px solid #fdba74",
                              flexShrink: 0,
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                              <span
                                style={{
                                  fontWeight: 700,
                                  color: "#c2410c",
                                  fontSize: "1.05rem",
                                }}
                              >
                                {homeMain.lab_ref.title}
                              </span>
                              <span
                                className="badge rounded-pill"
                                style={{
                                  backgroundColor: "#ffedd5",
                                  color: "#c2410c",
                                  fontSize: "0.75rem",
                                  padding: "6px 10px",
                                }}
                              >
                                {homeMain.lab_ref.resourceType}
                              </span>
                            </div>
                            <p
                              style={{
                                color: "#7c2d12",
                                fontSize: "0.85rem",
                                lineHeight: 1.5,
                                marginBottom: "8px",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                width: "750px",
                              }}
                            >
                              {homeMain?.lab_ref?.description}
                            </p>
                            <span
                              style={{ fontSize: "0.8rem", color: "#9a3412" }}
                            >
                              {homeMain?.lab_ref?.estimatedDurationMinutes} mins
                            </span>
                          </div>
                          <button
                            className="btn"
                            style={{
                              backgroundColor: "#f97316",
                              color: "#ffffff",
                              borderRadius: "10px",
                              padding: "8px 20px",
                              fontWeight: 600,
                              fontSize: "0.9rem",
                              border: "none",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => {
                              const previewData = {
                                selectedLab: homeMain.lab_ref,
                                activityData: {
                                  title: homeMain.name,
                                  description: homeMain.description,
                                  className: homeMain?.standard_id?.name,
                                  subjectName: homeMain?.subject_id?.name,
                                  chapterName:
                                    homeMain?.chapter_id?.chapterName || "",
                                  duration: homeMain?.duration || "20 minutes",
                                },
                              };

                              localStorage.setItem(
                                "activityPreviewData",
                                JSON.stringify(previewData),
                              );

                              const features = [
                                "toolbar=no",
                                "location=no",
                                "directories=no",
                                "status=no",
                                "menubar=no",
                                "scrollbars=yes",
                                "resizable=yes",
                                "fullscreen=yes",
                                `width=${window.screen.availWidth}`,
                                `height=${window.screen.availHeight}`,
                                "top=0",
                                "left=0",
                              ].join(",");

                              const newWindow = window.open(
                                "/activity-lab-preview.html",
                                "_blank",
                                features,
                              );

                              if (newWindow) {
                                newWindow.moveTo(0, 0);
                                newWindow.resizeTo(
                                  window.screen.availWidth,
                                  window.screen.availHeight,
                                );
                                newWindow.focus();
                              }
                            }}
                          >
                            Open Activity
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="d-flex flex-wrap gap-3 mt-4">
                    {homeMain?.attachments?.length > 0 &&
                      homeMain?.attachments?.map((attachment, index) => (
                        <div
                          className="flex cursor-pointer"
                          key={index}
                          onClick={() => {
                            const fileType = attachment.split(".").pop();
                            if (
                              fileType === "jpg" ||
                              fileType === "jpeg" ||
                              fileType === "png" ||
                              fileType === "mp4" ||
                              fileType === "JPG" ||
                              fileType === "JPEG" ||
                              fileType === "PNG" ||
                              fileType === "MP4"
                            ) {
                              handleClick(attachment);
                            } else if (
                              fileType === "pdf" ||
                              fileType === "PDF" ||
                              fileType === "ppt" ||
                              fileType === "PPT" ||
                              fileType === "PPTX" ||
                              fileType === "pptx"
                            ) {
                              handleClickforpdf(attachment);
                            }
                          }}
                        >
                          <>
                            {attachment.split(".").pop() === "jpg" ||
                            attachment.split(".").pop() === "jpeg" ||
                            attachment?.split(".").pop() === "JPEG" ||
                            attachment?.split(".").pop() === "JPG" ||
                            attachment?.split(".").pop() === "PNG" ||
                            attachment?.split(".").pop() === "mp4" ||
                            attachment?.split(".").pop() === "MP4" ||
                            attachment.split(".").pop() === "png" ? (
                              <div
                                onClick={() => {
                                  if (!isError) {
                                    handleClick(attachment);
                                    console.log("click");
                                  }
                                }}
                                style={
                                  isError
                                    ? { pointerEvents: "none", opacity: 0.5 }
                                    : {}
                                }
                                className="d-flex gap-2 p-1"
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    src={`${
                                      iconData?.find(
                                        (i) =>
                                          i.extension ===
                                          attachment?.split(".").pop(),
                                      )?.icon
                                    }`}
                                    alt=""
                                    className="w-8"
                                  />
                                </div>
                              </div>
                            ) : attachment.split(".").pop() === "pdf" ? (
                              <div
                                className="d-flex align-items-center"
                                onClick={() => handleClickforpdf(attachment)}
                              >
                                <img
                                  className="w-8"
                                  src={`${
                                    iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment?.match(/\.([^.]+)$/)[1],
                                    )?.icon
                                  }`}
                                  alt=""
                                />
                              </div>
                            ) : (
                              attachment.startsWith("https://") && (
                                <div
                                  onClick={() =>
                                    window.open(
                                      attachment,
                                      "_blank",
                                      "noopener,noreferrer",
                                    )
                                  }
                                  className="flex gap-2 items-center"
                                >
                                  <div className="mb-2">
                                    <img
                                      src="/images/link-icon.png"
                                      alt=""
                                      className="w-10"
                                      style={{ width: 40, height: 40 }}
                                    />
                                  </div>
                                  <div className="text-sm font-weight-medium text-center">
                                    <div
                                      style={{
                                        maxWidth: "180px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {(() => {
                                        try {
                                          const url = new URL(attachment);
                                          if (
                                            url.hostname.includes(
                                              "youtube.com",
                                            ) ||
                                            url.hostname.includes("youtu.be")
                                          ) {
                                            return "YouTube Video";
                                          }
                                          return url.hostname.replace(
                                            "www.",
                                            "",
                                          );
                                        } catch {
                                          return attachment;
                                        }
                                      })()}
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </>
                          {attachment.startsWith("https://") ? null : (
                            <div
                              className="pdf_detail font-semibold"
                              style={{ marginLeft: "5px" }}
                            >
                              <div
                                className="pdf-txt2"
                                title={attachformat(attachment)}
                                style={{
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  maxWidth: "100px",
                                }}
                              >
                                {attachformat(attachment)}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </div>

                {/* ═══════════════════════════════════════════════════
                  ANSWER / RESPONSE SECTION
                  ═══════════════════════════════════════════════════ */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    border: "2px solid #d0d7de",
                    borderRadius: "12px",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: 700,
                      color: "#6c757d",
                      textTransform: "uppercase",
                      letterSpacing: "0.6px",
                      marginBottom: "16px",
                      borderBottom: "1px solid #dee2e6",
                      paddingBottom: "8px",
                    }}
                  >
                    ✍️ Your Response
                  </div>

                  <div style={{ position: "relative" }} className="mt-3 mb-3">
                    <textarea
                      placeholder="Type to write your answer here."
                      rows={6}
                      className="textInputQuestion p-3"
                      maxLength={2500}
                      value={descriptive_answer}
                      onChange={(e) => setDescriptive_answer(e.target.value)}
                      style={{
                        minHeight: "90px",
                        height: "auto",
                        resize: "vertical",
                      }}
                    ></textarea>
                    <div
                      className="maxWordCount"
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        right: "10px",
                      }}
                    >
                      {descriptive_answer.length}/{2500}
                    </div>
                  </div>

                  <div className="d-flex gap-3 mt-4">
                    {!isCameraOpen ? (
                      <div
                        onClick={() => setIsCameraOpen(true)}
                        className="cameraContainerActivity"
                      >
                        <div style={{ padding: "15px" }}>
                          <div className="d-flex justify-content-center">
                            <img src="/HwImg/CameraIcon.png" alt="" />
                          </div>
                          <div className="uploadHereText d-flex justify-content-center mt-2">
                            Upload your files here
                          </div>
                          <div className="openCamera d-flex justify-content-center mt-1">
                            Capture
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="opended_camera">
                        <img
                          onClick={() => setIsCameraOpen(!isCameraOpen)}
                          className="cross_icon"
                          src="/DCM-img/crossIcon.svg"
                          alt="cross logo"
                        />
                        <Camera
                          onTakePhoto={(dataUri) => {
                            handleTakePhoto(dataUri);
                          }}
                          idealFacingMode={"environment"}
                          isImageMirror={false}
                          imageCompression={0.97}
                          isMaxResolution={true}
                          isSilentMode={false}
                          onCameraError={handleCameraError}
                        />
                      </div>
                    )}
                    <div>
                      <input
                        type="file"
                        id="attachFile"
                        accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx"
                        multiple
                        onChange={(e) => handleAttachment(e.target.files)}
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor="attachFile"
                        style={{ marginBottom: "0px" }}
                      >
                        <div className="cameraContainerActivity">
                          <div style={{ padding: "18px 15px" }}>
                            <div className="d-flex justify-content-center">
                              <img
                                src="/HwImg/UploadFileIcon.png"
                                alt=""
                                style={{ width: "45%" }}
                              />
                            </div>
                            <div className="uploadHereText d-flex justify-content-center mt-2">
                              Upload your files here
                            </div>
                            <div className=" openCamera d-flex justify-content-center mt-1">
                              Choose file
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="d-flex flex-wrap gap-4 flex-wrap">
                    {attachFile?.length > 0 &&
                      attachFile?.map((attach, index) => (
                        <div
                          className="d-flex pdfContainer gap-2 p-2 mt-4 "
                          key={index}
                        >
                          <div
                            onClick={() => setIsOpen(attach)}
                            className="d-flex align-items-center"
                          >
                            <img
                              className="extention_icon"
                              src={`${
                                iconData?.find(
                                  (i) =>
                                    i.extension ===
                                    attach?.match(/\.([^.]+)$/)[1],
                                )?.icon
                              }`}
                              alt=""
                            />
                          </div>
                          <div
                            onClick={() => setIsOpen(attach)}
                            className=""
                            style={{ width: "75%" }}
                          >
                            <div
                              className="pdfName"
                              title={attach?.replace(/^[^_]*_/, "")}
                            >
                              {attach?.replace(/^[^_]*_/, "")}
                            </div>
                            <div className="pdfFileSize">
                              {Math.floor(attachmentSize[index] / 1024)} KB
                            </div>
                            <div className="d-flex justify-content-end">
                              <img src="/HwImg/PdfRightIcon.png" alt="" />
                            </div>
                          </div>

                          <div
                            onClick={() =>
                              handleRemoveAttachment(attach, index)
                            }
                            className="CrossPdfIcon"
                            style={{ overflow: "visible" }}
                          >
                            <img src="/HwImg/CrossPdfIcon.png" alt="" />
                          </div>
                        </div>
                      ))}
                  </div>

                  <div className="d-flex justify-content-end mt-2">
                    <button
                      className="btn submitBtnActivity"
                      onClick={() => setIsConfirmPopup(true)}
                      disabled={
                        attachFile.length === 0 && descriptive_answer === ""
                      }
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {activitySubDetail && (
              <SucessfullySubmited
                setActivitySubDetail={setActivitySubDetail}
              />
            )}
            {isConfirmPopup && (
              <ConfirmPopupActivity
                setIsConfirmPopup={setIsConfirmPopup}
                handleSubmit={handleSubmit}
              />
            )}
          </div>
        </div>
      ) : isGettingData ? (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ minHeight: "600px" }}
        >
          <div className="position-relative">
            <div
              className="spinner-grow text-warning"
              role="status"
              style={{ width: "60px", height: "60px" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <div
              className="spinner-grow text-primary position-absolute top-0 start-50 translate-middle"
              style={{ width: "40px", height: "40px", animationDelay: "0.2s" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          <span
            className="mt-4 text-muted"
            style={{
              fontSize: "15px",
              fontWeight: 500,
              letterSpacing: "0.3px",
            }}
          >
            Please wait...
          </span>
        </div>
      ) : (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <div className="d-flex justify-content-center h-20 align-items-center w-100">
            <span
              className="badge bg-light text-dark  rounded-pill px-4 py-3"
              style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
            >
              📭 Activity Not Found
            </span>
          </div>
        </div>
      )}
      {/* PDF/Media Viewers */}
      {mideaviewer && (
        <PdfViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
      {isOpen &&
        (isOpen.split(".").pop() === "jpg" ||
        isOpen.split(".").pop() === "jpeg" ||
        isOpen.split(".").pop() === "JPEG" ||
        isOpen.split(".").pop() === "JPG" ||
        isOpen.split(".").pop() === "PNG" ||
        isOpen.split(".").pop() === "png" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <img
                className="imgMain"
                src={IP + isOpen?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleRemovePdfVivwer}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : isOpen.split(".").pop() === "mp4" ||
          isOpen.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleRemovePdfVivwer}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <PdfViewer
            handleRemovePdfVivwer={handleRemovePdfVivwer}
            attachment={isOpen}
          />
        ))}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
        responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    onClick={() => {
                      setIsError(false);
                      handleClick();
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
      {handleVideoClick && (
        <div className="fullSizeImg ">
          <div className="SubfullSizeImgVideo">
            <div>
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
            </div>
            <div>
              <img
                className="crossIconImgQue"
                onClick={handleClickForVideo}
                src="/DCM-img/crossIcon.svg"
                alt="Up Arrow"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
